function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("WhiteBox sends status labels to Google Analytics and Facebook Pixel for each user, based on their combined current and past behavior (online and offline).")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Reading about specific content")]),_vm._v(" "),_c('li',[_vm._v("Frequency of user visits")]),_vm._v(" "),_c('li',[_vm._v("User experience began with specific interest (e.g. Google Search to a specific page)")]),_vm._v(" "),_c('li',[_vm._v("At which stage of the sales funnel the user is Lead, Prospect, Customer or Returning customer")]),_vm._v(" "),_c('li',[_vm._v("An offer has been seen by the user (if sent via email)")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/home/conversions/details","summary":"Offline conversions are tricky"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }